import { ISaveService } from "../../../../../abstractions/services/actions/ISaveService";
import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { RotacionPesajeVeterinariaRequest } from "../../../../../modulos/pesaje/ganaderia/request/RotacionPesajeVeterinariaRequest";
import { RotacionPesajeVeterinariaResponse } from "../../../../../modulos/pesaje/ganaderia/response/RotacionPesajeVeterinariaResponse";
import { RotacionPesajeVeterinariaSaveGrpcService } from "../../../../../modulos/pesaje/ganaderia/services/RotacionPesajeVeterinariaSaveGrpcService";
import { ClienteFincaLoteResponse } from "../../../../../modulos/terceros/response/ClienteFincaLoteResponse";
import { BaseFullScreenFormModalRender } from "../../../../base/modal/BaseFullScreenFormModalRender";
import { IFormBodyRender } from "../../../../definitions/form/IFormBodyRender";
import { RotacionPesajeVeterinariaFormRender } from "../form/RotacionPesajeVeterinariaFormRender";

/** Modal a pantalla completa de creación/edición de un evento de Pesaje /
 *  Rotación / Veterinaria. Hospeda el `RotacionPesajeVeterinariaFormRender` y
 *  guarda con `RotacionPesajeVeterinariaSaveGrpcService`. Si viene del mapa con el
 *  potrero origen fijo, lo muestra en el subtítulo y bloquea su selector. */
export class RotacionPesajeVeterinariaModalRender extends BaseFullScreenFormModalRender<
  RotacionPesajeVeterinariaRequest,
  RotacionPesajeVeterinariaResponse
> {
  protected readonly elementId = "rotacionPesajeVeterinariaModal";

  /**
   * @param request         Request a crear/editar.
   * @param _loteOrigenFijo Potrero origen fijo (viene del mapa): se muestra en
   *                        el subtítulo y no puede cambiarse en el form.
   */
  constructor(
    request: RotacionPesajeVeterinariaRequest,
    private readonly _loteOrigenFijo?: ClienteFincaLoteResponse,
  ) {
    super(request);
  }

  protected get title(): string {
    return "Pesaje / Rotación / Veterinaria";
  }

  protected get subtitle(): string | undefined {
    const nombreFinca = serviceProvider.getFincaSelectedService().get()
      ?.nombreFinca;
    if (this._loteOrigenFijo) {
      return `${nombreFinca} → ${this._loteOrigenFijo.nombreLote}`;
    }
    return nombreFinca;
  }

  protected get saveLabel(): string {
    return "Registrar Evento";
  }

  /** Form actual (para pedirle la tira de badges del footer). */
  private _formRender: RotacionPesajeVeterinariaFormRender | null = null;

  protected getFormBody(): IFormBodyRender {
    this._formRender = new RotacionPesajeVeterinariaFormRender(
      this._request,
      this._loteOrigenFijo,
    );
    return this._formRender;
  }

  /** Tira "Se registrará:" con los badges de las secciones activas. */
  protected getFooterLeft(): string {
    return this._formRender?.renderFooterBadges() ?? "";
  }

  protected get saveService(): ISaveService<
    RotacionPesajeVeterinariaRequest,
    RotacionPesajeVeterinariaResponse
  > {
    return new RotacionPesajeVeterinariaSaveGrpcService();
  }
}
